import type { LongLat } from "../components/FormComponents/MapComponent";

// Default location coordinates (London)
export const LONDON_COORDS: LongLat = {
  Latitude: 51.5074,
  Longitude: -0.1278
};
